import {
    getAlternatePremiumCalculation,
    getIsUsdRateApiPending,
    getPremiumCalculation,
} from '../../../selectors/travelUg/quote';
import {
    apiTransitionUsdRate,
    setUgxPremium,
    setUsdRate,
    setAlternateUgxPremium,
} from '../../../actions/travelUg/quote';
import { getAccessToken } from '../../../selectors/travelUg/payments';
import axios from 'axios';

export const getUsdRateService = async (store, next, action) => {
    const state = store.getState();

    if (!getIsUsdRateApiPending(state)) {
        store.dispatch(apiTransitionUsdRate.pending());

        try {
            const response = await calculate(state);
            const usdRate = Number(response.data.rate);

            store.dispatch(setUsdRate(usdRate));
            store.dispatch(apiTransitionUsdRate.success());

            const premiumCalculation = getPremiumCalculation(store.getState());
            const alternatePremiumCalculation = getAlternatePremiumCalculation(store.getState());

            const ugxPremium = Math.ceil(premiumCalculation?.value?.totalPremium * usdRate);
            const alternateUgxPremium = Math.ceil(alternatePremiumCalculation?.value?.totalPremium * usdRate);

            store.dispatch(setUgxPremium(ugxPremium));
            store.dispatch(setAlternateUgxPremium(alternateUgxPremium));
        } catch (error) {
            console.error(error);
            store.dispatch(apiTransitionUsdRate.failure());
        }
    }

    return next(action);
};

const calculate = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/travel-ug/usd-rate';
        return await axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
